
import React from 'react';

const FAQ = () => {
  return (
    <div className="mt-20 max-w-3xl mx-auto animate-slide-up [animation-delay:500ms] opacity-0">
      <h2 className="text-2xl font-bold mb-8 text-center">Frequently Asked Questions</h2>
      <div className="space-y-6">
        <div className="space-y-2">
          <h3 className="text-lg font-medium">Can I cancel anytime?</h3>
          <p className="text-muted-foreground">Yes, you can cancel your subscription at any time. Your access will continue until the end of your current billing period.</p>
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-medium">What payment methods do you accept?</h3>
          <p className="text-muted-foreground">We accept all major credit cards, PayPal, and Apple Pay.</p>
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-medium">What's included in the Lifetime plan?</h3>
          <p className="text-muted-foreground">The Lifetime plan includes all current and future features of Dropify with no recurring fees, ever. It's a one-time payment for permanent access.</p>
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-medium">How does the free trial work?</h3>
          <p className="text-muted-foreground">Both Monthly and Annual plans include a 14-day free trial. You'll only be charged after the trial period ends, and you can cancel anytime during the trial period with no charges.</p>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
